import { Component } from 'opus-angular-seed-core';

@Component({
    transclude: true,
    bindings: {
        hasBurger: '<?',
        isMenuActive: '<?'
    },
    template: `
        <div class="container" ng-class="{ active: vm.isMenuActive }">
            <ng-transclude></ng-transclude>
        </div>
        <style>
            learn-modal {
                display: contents;
            }

            .modal-dialog:has(.container) .container {
                height: 100%;
            }

            .material-preview:has(.container) {
                height: 100%;
            }

            .modal-body:has(.container):last-child {
                border-radius: 0;
            }

            .container {
                --color-gray-1: #dbdbdb;
                --color-gray-2: #f6f6f6;
                --color-gray-3: #e5e5ec;
                --color-white: #fff;
                --color-white-2: #f6f6f9;
                --color-black: #170c40;
                --color-brand: blue;
                --background-gray: var(--color-gray-1);
                --background-gray-2: var(--color-gray-2);
                --background-white: var(--color-white);
                --background-black: var(--color-black);
                --icon-size-1: 70px;
                --icon-size-2: 60px;
                --icon-font-size: 21px;
                --border-size: 1px;
                --max-content-width: 900px;
                --spacing: 20px;
                --gap: 1px;
                display: flex;
                flex-direction: column;
                gap: var(--gap);
                background: var(--background-gray);
                height: 100vh;
                max-height: 100%;
                width: 100%;
            }

            ng-transclude {
                display: contents;
            }

            .topbar {
                flex: 0 0 auto;
            }

            .materials-wrapper {
                position: relative;
                flex: 1 1 auto;
                max-height: calc(100% - var(--icon-size-1) - var(--border-size));
            }

            .container h1 {
                margin: 0;
                font-size: 16px;
                font-weight: 400;
            }

            .topbar {
                display: flex;
                align-self: stretch;
                justify-content: end;
                width: 100%;
                align-items: center;
                background: var(--background-white);
            }

            .progress-wrapper {
                display: none;
                gap: 20px;
                align-items: center;
            }

            .progress-wrapper progress {
                -webkit-appearance: none;
                appearance: none;
                width: 100px;
                height: 10px;
                vertical-align: middle;
                border: none;
                background-color: var(--background-gray);
                border-radius: 5px;
            }

            .progress-wrapper label {
                line-height: 14px;
            }

            .progress-wrapper progress::-webkit-progress-bar {
                background-color: var(--background-gray);
                border-radius: 5px;
            }
            .progress-wrapper progress::-webkit-progress-value {
                background-color: var(--brand-main, var(--color-brand));
                border-radius: 5px;
            }
            .progress-wrapper progress::-moz-progress-bar {
                background-color: var(--brand-main, var(--color-brand));
                border-radius: 5px;
            }

            .close-icon,
            .burger {
                cursor: pointer;
                position: relative;
                height: var(--icon-size-1);
                min-height: var(--icon-size-1);
                flex: 0 0 var(--icon-size-1);
                box-sizing: border-box;
            }

            .close-icon {
                border-left: 1px solid var(--background-gray);
            }

            .close-icon::before {
                width: 20px;
                height: 1px;
            }

            .close-icon::before,
            .close-icon::after {
                content: ' ';
                background: var(--background-black);
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(45deg);
            }

            .close-icon::after {
                width: 1px;
                height: 20px;
            }

            .burger {
                border-right: 1px solid var(--background-gray);
                text-align: center;
                place-content: center;
                align-content: center;
                font-size: var(--icon-font-size);
            }

            .burger::before {
                vertical-align: middle;
            }

            .sidebar {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                display: none;
                background: var(--background-white);
                z-index: 10;
            }

            .sidebar-heading {
                display: flex;
                align-items: center;
                padding: 10px 20px;
            }

            .sidebar-content {
                height: calc(100% - var(--icon-size-2) - var(--border-size));
                overflow: auto;
            }

            .container.active .sidebar .sidebar-heading {
                border-bottom: 1px solid var(--background-gray);
            }

            .sidebar-toggle {
                display: none;
                cursor: pointer;
                width: var(--icon-size-2);
                height: calc(var(--icon-size-2) - 5px);
                font-size: var(--icon-font-size);
                text-align: center;
                place-content: center;
            }

            .sidebar-toggle::before {
                line-height: 27px;
                align-items: center;
                display: flex;
                justify-content: center;
            }

            .content {
                flex: 1 1 auto;
                overflow: auto;
                flex-direction: column;
                display: flex;
                background: var(--background-gray-2);
            }

            .content-panel {
                align-self: center;
                display: flex;
                width: 100%;
            }

            .content-panel .content-container > ng-transclude > div {
                width: 100%;
                overflow: auto;
            }

            .content-panel .content-container > ng-transclude > div > figure {
                max-height: 100%;
            }

            .content-panel .content-container > ng-transclude > div > iframe {
                width: 100%;
                aspect-ratio: 16 / 9;
                max-width: 100%;
            }

            .content-footer button {
                font-family: Poppins, Arial, Helvetica, sans-serif;
                outline: none;
                display: inline-block;
                vertical-align: middle;
                appearance: none;
                box-sizing: border-box;
                position: relative;
                z-index: 0;
                padding: 0 20px;
                line-height: 1;
                height: 40px;
                margin: 0;
                border: none;
                border-radius: 7px;
                background: var(--background-gray-2);
                font-size: 14px;
                color: var(--color-black);
                cursor: pointer;
                transition: all 0.25s ease-in-out 0ms;
                will-change: border, background;
                text-align: center;
            }

            .content-footer .main-button {
                background: var(--brand-main, var(--color-brand));
                color: var(--color-white);
            }

            .content-footer .main-button:hover {
                opacity: 0.7;
            }

            .content-footer button.disabled,
            .content-footer button[disabled='disabled'],
            .content-footer button[disabled],
            .content-footer button:disabled {
                cursor: default;
                opacity: 0.5;
                pointer-events: none;
            }

            .content-footer .secondary-button {
                background: var(--color-white);
                border: 2px solid var(--color-gray-3);
            }

            .content-footer .secondary-button:hover {
                border-color: var(--color-black);
                background: transparent;
                color: var(--color-black);
                text-decoration: none;
            }

            .container.active .sidebar {
                display: block;
                height: 100%;
            }

            .frame-wrapper:has(learn-modal > .container) {
                padding-bottom: 0;
            }

            .content .content-panel video {
                border-radius: 10px;
                max-width: 900px;
                width: 100% !important;
                aspect-ratio: 16 / 9;
            }

            .content-panel iframe.material-preview.material-preview-pdf:not(.pfs),
            .content-panel iframe.material-preview.material-preview-powerpoint:not(.pfs) {
                width: 100% !important;
                aspect-ratio: 0.5;
            }

            .content-panel iframe.material-preview.pfs {
                position: fixed;
                inset: 0;
                width: 100dvw !important;
                height: 100dvh !important;
                max-width: none;
                max-height: none;
                margin: 0;
                border: none;
                z-index: 9999;
                background: #000;
                display: block;
            }

            .content .media-selected-wrapper:has(.material-preview.pfs) {
                position: fixed !important;
                inset: 0;
                margin: 0;
                max-width: none;
                width: 100vw;
                height: 100dvh;
                background: #000;
                z-index: 9999;
            }

            @media (min-width: 768px) {
                .burger {
                    display: none;
                }

                .container .sidebar .sidebar-heading {
                    padding: 0;
                    justify-content: end;
                }

                .container.active .sidebar .sidebar-heading {
                    padding: 0 0 0 20px;
                    justify-content: space-between;
                }

                .sidebar-toggle {
                    display: block;
                }

                .progress-wrapper {
                    display: flex;
                }

                .progress-wrapper progress {
                    width: 200px;
                }

                .sidebar {
                    position: relative;
                    display: block;
                    top: 0;
                    flex: 0 0 var(--icon-size-1);
                    border-right: 1px solid var(--background-gray);
                    transition: flex 0.3s ease-in-out;
                }

                .container.active .sidebar {
                    flex: 0 0 340px;
                }

                .container .sidebar .sidebar-toggle {
                    transform: rotate(180deg);
                    border: 0;
                }

                .container.active .sidebar .sidebar-toggle {
                    transform: rotate(0deg);
                    border-left: 1px solid var(--background-gray);
                }
            }
        </style>
    `
})
export default class {
    constructor () {
        this.isMenuActive = false;
        this.hasBurger = false;
    }

    toggleMenu () {
        this.isMenuActive = !this.isMenuActive;
    }

    closeModal () {
        window.parent.postMessage('action:closeMaterialDialog', '*');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/learnModal/index.js